export function searchDropdown() {
    const searchBtn = $('#toolbarSearch');
    const searchPanel = $('#search-panel');
    const overlay = $('.site-overlay-dark');
    const slideDuration = 350;
    const slideEasing = 'swing';

    function openPanel() {
        //Only one header panel at a time — close any open megamenu panel
        //(its MutationObserver handles the slide/overlay hand-off)
        $('.accessible-megamenu-panel.open')
            .removeClass('open')
            .attr('aria-hidden', 'true');
        $('.accessible-megamenu-top-nav-item [aria-expanded=true]')
            .attr('aria-expanded', 'false')
            .removeClass('open');
        //...and the login panel
        $('.olb-login').removeClass('show-login');

        $('header').addClass('search-active');
        overlay.stop(true, true).fadeIn(slideDuration);
        searchPanel.stop(true, true).slideDown(slideDuration, slideEasing);
        searchBtn.attr('aria-expanded', 'true');
    }

    function closePanel() {
        searchPanel.stop(true, true).slideUp(slideDuration, slideEasing, function() {
            $('header').removeClass('search-active');
            //A megamenu panel may have taken over the overlay — leave it up
            if (!$('.accessible-megamenu-panel.open').length) {
                overlay.stop(true, true).fadeOut(slideDuration);
            }
        });
        searchBtn.attr('aria-expanded', 'false');
    }

    searchBtn.on('click', function(e) {
        e.preventDefault();
        if (searchPanel.is(':visible')) {
            closePanel();
        } else {
            openPanel();
        }
    });

    //Clicking the overlay or anywhere outside the panel closes it
    $(document).on('click', function(e) {
        if (searchPanel.is(':visible') && !$(e.target).closest('#search-panel, #toolbarSearch').length) {
            closePanel();
        }
    });

    //Opening a megamenu panel closes the search panel. The megamenu plugin
    //stops click propagation, so bind directly on the links.
    $('.megamenu a').on('click', function() {
        if (searchPanel.is(':visible')) {
            closePanel();
        }
    });

    //Escape closes the panel
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && searchPanel.is(':visible')) {
            closePanel();
        }
    });

    //The toolbar (and search button) is hidden below the lg breakpoint, so
    //resizing into mobile resets the panel instantly — no slide animation
    const DESKTOP_BREAKPOINT = 1160;
    $(window).on('resize', function() {
        if (window.innerWidth < DESKTOP_BREAKPOINT && searchPanel.is(':visible')) {
            searchPanel.stop(true, true).hide();
            $('header').removeClass('search-active');
            searchBtn.attr('aria-expanded', 'false');
            if (!$('.accessible-megamenu-panel.open').length) {
                overlay.stop(true, true).hide();
            }
        }
    });
}
